<script setup>
import AppHeader from '@elements/AppHeader.vue'
import getCurrentLanguage from '@/helpers/getCurrentLanguage.js'
import ScrollToTopButton from '@elements/ScrollToTopButton.vue'
import { onMounted } from 'vue'
import { setI18nLanguage } from '@/helpers/i18n.js'
import { useFeaturesStore } from '@/stores/useFeaturesStore.js'
import { useModulesStore } from '@/stores/useModulesStore.js'
import { usePermissionsStore } from '@/stores/usePermissionsStore.js'
import { usePreferencesStore } from '@/stores/usePreferencesStore.js'
import { useSettingsStore } from '@/stores/useSettingsStore.js'

const features = useFeaturesStore()
const modules = useModulesStore()
const permissions = usePermissionsStore()
const preferences = usePreferencesStore()
const settings = useSettingsStore()

onMounted(async () => {
	const language = getCurrentLanguage()
	await setI18nLanguage(language)
	await Promise.allSettled([
		features.fetch(false),
		modules.fetch(false),
		permissions.fetch(false),
		preferences.fetch(false),
		settings.fetch(false),
	])
})
</script>

<template>
	<div class="app-wrapper">
		<a
			class="visually-hidden-focusable skip-to-content bg-info"
			href="#main"
		>Skip to content</a>

		<AppHeader />

		<main id="main">
			<div class="container">
				<router-view />
			</div>
		</main>

		<ScrollToTopButton />
	</div>
</template>
